import { useEffect } from 'react';

type HeapProperties = Record<string, string | number | boolean | null | undefined>;

export function useHeapEventProperties(properties: HeapProperties): void {
  useEffect(() => {
    window.heap?.addEventProperties(properties);

    return () => {
      Object.keys(properties).map((property) => {
        window.heap?.removeEventProperty(property);
      });
    };
  }, [properties]);
}
